<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb :page-title="$t('categories')" :directory="$t('datatables')" :icon="'grid'"/>
      </div>
      <div class="col-sm-12 col-md-6 breadcrumb-side-button">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button type="button"
                  class="btn btn-primary btn-with-shadow"
                  data-toggle="modal"
                  @click="openAddEditModal">
            {{ $t('addcategory') }}
          </button>
        </div>
      </div>
    </div>

    <app-table
        :id="tableId"
        :options="options"
        @action="getListAction"
    />

    <category-addmodal
        v-if="isAddEditModalActive"
        :table-id="tableId"
        :selected-url="selectedUrl"
        @close-modal="closeAddEditModal"
    />

    <app-delete-modal
        v-if="deleteConfirmationModalActive"
        :preloader="deleteLoader"
        modal-id="demo-delete"
        @confirmed="confirmed"
        @cancelled="cancelled"
    />

    <invoice-datatable></invoice-datatable>
  </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../Config/ApiUrl";
import {TableHelpers} from '../../Demo/Tables/mixins/TableHelpers';


export default {
  extends: CoreLibrary,
  name: "CategoryIndex",
  mixins: [TableHelpers],
  data() {
    return {
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      selectedUrl: '',
      tableId: 'category-index-table',
      rowData: {},
      options: {
        name: 'CategoryIndexTable',
        url: actions.CATEGORY_LISTING,
        showHeader: true,
        columns: [
          {
            title: this.$t('title'),
            type: 'custom-html',
            key: 'title',
            isVisible: true,
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`
            }
          },

        ],
        actions: [

          {
            title: this.$t('edit'),
            icon: 'edit',
            type: 'none',
            component: 'app-add-modal',
            modalId: 'demo-add-edit-Modal',

          },
          {
            title: this.$t('delete'),
            icon: 'trash',
            type: 'none',
            component: 'app-confirmation-modal',
            modalId: 'demo-delete',
          }
        ],

        showFilter: false,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: 'desc',
        actionType: "dropdown",
      }
    }
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    this.searchAndSelectFilterOptions();
  },
  methods: {
    /**
     * for open add edit modal
     */
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    /**
     * $emit Form datatable action
     */
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      if (actionObj.title == 'Delete') {
        this.openDeleteModal();
      } else if (actionObj.title == this.$t('edit')) {
        this.selectedUrl = `${actions.CATEGORY_SHOW}/${rowData.id}`;
        this.openAddEditModal();
      }
    },

    /**
     * for close add edit modal
     */
    closeAddEditModal() {
      $("#demo-add-edit-Modal").modal('hide');
      this.isAddEditModalActive = false;
      this.searchAndSelectFilterOptions();
      this.reSetData();
    },

    /**
     * for open confirmation modal
     */
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    /**
     * confirmed $emit Form confirmation modal
     */
    confirmed() {
      let url = `${actions.DATATABLE_DATA}/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosDelete(url)
          .then(response => {
            this.deleteLoader = false;
            $("#demo-delete").modal('hide');
            this.cancelled();
            this.$toastr.s(response.data.message);
            this.searchAndSelectFilterOptions();
          }).catch(({error}) => {
        // Trigger after error
      }).finally(() => {
        this.$hub.$emit('reload-' + this.tableId);
      });
    },

    /**
     * cancelled $emit Form confirmation modal
     */
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },
    reSetData() {
      this.rowData = {};
      this.selectedUrl = '';
    },
    searchAndSelectFilterOptions() {
      this.axiosGet(actions.DATATABLE_SEARCH_SELECT).then(response => {
        let name = this.options.filters.find(element => element.title === this.$t('search_and_select'));

        name.option = response.data.map(name => {
          return {
            id: name.name,
            value: name.name
          }
        });
      });
    }
  },
}
</script>
